export default function PropertiesApi({ makeRequest, buildRequest }) {

    function getProperties() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Properties'));
        });
    }

    function getPropertiesSummary() {
        return buildRequest().then(function (req) {
            return makeRequest(req.get('/api/Properties/Summary'));
        });
    }

    function getPropertiesByCentre(centreId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Properties/ByCentre/${centreId}`));
        });
    }

    function getPropertyById(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.get(`/api/Properties/${propertyId}`));
        });
    }

    function upsertProperty(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Properties/Upsert', payload));
        });
    }

    function upsertPropertyDetailed(payload) {
        return buildRequest().then(function (req) {
            return makeRequest(req.post('/api/Properties/UpsertDetailed', payload));
        });
    }

    function deleteProperty(propertyId) {
        return buildRequest().then(function (req) {
            return makeRequest(req.delete(`/api/Properties/${propertyId}`));
        });
    }

    return {
        getProperties,
        getPropertiesSummary,
        getPropertiesByCentre,
        getPropertyById,
        upsertProperty,
        upsertPropertyDetailed,
        deleteProperty,
    };
}
